import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ReactDom from 'react-dom';
import Moment from 'react-moment';

import { ArticlePage } from './Article';
import { MetaDataBar, TagBar } from './Utils';

const PostPage = ({ match }) => (
	<div>
		<ArticlePage name={match.params.postname} />
	</div>
)



export class Post extends Component {
	render() {
		const {
			className,
			category,
			url,
			author,
			created,
			image,
			title,
			authorimage,
			imagecredit,
			tags
		} = this.props;


		return (
			<article className={`post ${className}`}>
				<MetaDataBar
					authorimage={authorimage}
					author={author}
					created={created}
					category={category}
				/>
				<div title={`Image by ${imagecredit}`} className='post-image'>
					<Link to={ `/post/${url}` }>
						<img src={`/articles/${url}/${image}`} className='post-preview'	alt={ title } />
					</Link>
				</div>
				<div className='post-details'>
					<div className='container row'>
						<div className='post-title'>
							<h2>{ title }</h2>
							<TagBar tags={tags} />
						</div>
						<div className='post-link'>
							<Link to={ `/post/${url}` }>
								_> less
							</Link>

						</div>
					</div>
				</div>
			</article>
		)
	}
}

class BlinkingCursor extends Component {
	constructor() {
		super();
		this.state = {
			active: false
		}
		this.componentDidMount = this.componentDidMount.bind(this);
	}
	componentDidMount() {
		this.interval = setInterval(() => {
			this.setState(prev => ({active: !prev.active}))
		}, 500);
	}

	componentWillUnmount() {
		clearInterval(this.interval);
	}

	render() {
		const { active } = this.state;
		return (
			<div className={'cursor ' + (active ? '' : 'active')}></div>
		)
	}
}

class PostMetaData extends Component {
	render() {
		const { authorimage, author, created } = this.props;
		return (
			<div className='post-meta'>
				<div  className='post-author-picture' style={{
						backgroundImage: `url(${ authorimage })`
					}}></div>
				<div className='post-author'>
					{ author }
				</div>
				<div className='post-date'>
					<Moment unix>{created}</Moment>
				</div>
			</div>
		)
	}
}

export default PostPage;



// WEBPACK FOOTER //
// ./src/Post.js